const getters = {
    statuses: state => state.statuses,
    criteriaBuilderColumns: state => state.criteria_builder_columns,
}

export default getters;
